<template>
    <div>
        <el-card>
            <div slot="header">
			    <span class="top_title">{{searchType==0?'草稿箱':'订货单'}}</span>
		    </div>
            <div>
                <div class="searchItem">
                    <div class="search">
                        <span class="searchtips">订单状态:</span>
                        <el-select
                            v-model="searchDate.state"
                            style="width:140px"
                        >
                            <el-option
                                v-for="(item,index) in orderState"
                                :key="index"
                                :value="item.value"
                                :label="item.label"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="search">
                        <span class="searchtips">时间:</span>
                        <el-date-picker
                            v-model="searchDate.dateRan"
                            type="daterange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 230px"
                            :editable="false"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </div>
                    <div class="search" v-if="$global.useinstall==1">
                        <span class="searchtips">安装地址:</span>
                        <el-input v-model="searchDate.address" maxlength="100" style="width:180px" clearable placeholder="请输入安装地址"></el-input>
                    </div>
                    <div class="search">
                        <el-button @click="advancedDialog=true">高级搜索</el-button>
                    </div>
                    <div class="search">
                        <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
                    </div>
                </div>
                <div style="display:flex;justify-content: space-between;">
                    <el-button @click="colsDialog = !colsDialog" style="height:40px">
                        列设置
                    </el-button>
                    <div>
                        <el-button v-if="searchType !== 0 && $global.userType!=1" type="primary"  @click="viewOrder(0)">查看草稿</el-button>
                        <el-button v-else-if="$global.userType!=1" type="primary" @click="viewOrder(1)">查看订单</el-button>
                        <el-button
                            type="primary"
                            icon="el-icon-plus"
                            @click="addOrder()"
                            v-if="$common.hasLimits('addOrder')&&$global.userType==0"
                            >新增订货</el-button
                        >
                        <el-button
                            type="primary"
                            icon="el-icon-printer"
                            @click="print"
                            v-if="$common.checkWindowsEnv()"
                            >打印</el-button>
                        <el-button
                            type="primary"
                            icon="el-icon-document"
                            @click="changePdf"
                        >导出</el-button>
                        <el-dropdown @command="setState" style="margin-left:10px">
                            <el-button type="primary">
                                <i class="el-icon-menu"></i><span>操作</span>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="6" v-if="$common.hasLimits('orderOpen')">通过</el-dropdown-item>
                                <el-dropdown-item command="-1" v-if="$common.hasLimits('orderClose')">关闭</el-dropdown-item>
                                <el-dropdown-item command="5" v-if="$common.hasLimits('orderLock')">锁定</el-dropdown-item>
                                <el-dropdown-item command="-2" v-if="$common.hasLimits('orderDelete')">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <el-table v-loading="loading" :data="tableData" style="width: 100%;margin:22px 0;" border @selection-change="handleSelectionChange" sort-change>
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="操作" width="120" align="center" >
                        <template slot-scope="scope">
                            <el-button type="text" @click="seeOrderDetail(scope.row)" v-if="$common.hasLimits('seeOrderDetail')">查看</el-button>
                            <el-button type="text" @click="orderDelete(scope.row)" v-if="$common.hasLimits('cDelete')&&scope.row.sendstatus==0">删除</el-button>
                            <el-button type="text" @click="orderDetail(scope.row)" v-if="$common.hasLimits('orderDetail')">编辑</el-button>
                            <el-button type="text" @click="orderDelete(scope.row)" v-if="$common.hasLimits('orderDelete')">删除</el-button>
                        </template>
                    </el-table-column>
                    <template v-for="(col, index) in cols">
                        <el-table-column 
                            :key="index" 
                            show-overflow-tooltip 
                            :prop="col.prop" 
                            :label="col.label" 
                            :width="col.width" 
                            :align="col.align"
                            v-if="col.show"
                        >
                            <template #header v-if="col.column">
                                {{col.label}}
                                <el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
                                <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
                                <el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
                                <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
                            </template>
                            <template slot-scope="{ row }">
                                <template v-if="col.type=='payType'">
                                    <template>
                                        <div>
                                            {{ row.price-row.freeSum-row.paySum }}
                                        </div>
                                    </template>
                                </template>
                                <template v-else-if="col.type=='linkType'">
                                    <template>
                                        <div :style="$common.hasLimits('orderDetail')?'cursor: pointer;color:#409EFF':''" @click="orderDetail(row)">{{ row.number }}</div>
                                    </template>
                                </template>
                                <template v-else-if="col.type=='sendstatus'">
                                    <template>
                                        <div v-if="row.sendstatus==-1" style="color:#ff2200">已关闭</div>
                                        <div v-else-if="row.sendstatus==0" style="color:#1890ff">待确认</div>
                                        <div v-else-if="row.sendstatus==1" style="color:#13ce66">已确认</div>
                                        <div v-else-if="row.sendstatus==3" style="color:#13ce66">部分开单</div>
                                        <div v-else-if="row.sendstatus==4" style="color:#999999">已开单</div>
                                        <div v-else-if="row.sendstatus==5" style="color:#ff2200">已锁定</div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div>{{row[col.prop]}}</div>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <el-pagination
                    style="text-align: right"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 120, 250]"
                    :page-size="cp_pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :pager-count="5"
                    :total="total"
                >
                </el-pagination>
            </div>
        </el-card>
        <el-dialog :visible.sync="colsDialog" title="列设置" width="60%">
			<column-edit :cols="cols" />
			<div slot="footer" class="dialog-footer">
                <el-button type="text" @click="cols = initCols();" style="float:left">恢复默认设置</el-button>
				<el-button type="primary" @click="saveCols">保存</el-button>
			</div>
		</el-dialog>
        <el-dialog title="高级搜索" :visible.sync="advancedDialog" width="60%">
			<el-form ref="advanceform" :inline="true" :model="searchDate" class="demo-form-inline" label-width="100px">
				<el-form-item label="订单号">
					<el-input v-model="searchDate.number" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="客户名称">
					<el-input v-model="searchDate.cust" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="商品名称">
					<el-input v-model="searchDate.prod" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="未发货商品">
					<el-input v-model="searchDate.notsend" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="searchDate.remark" placeholder="" style="width: 160px;" />
				</el-form-item>
                <el-form-item label="颜色">
					<el-input v-model="searchDate.color" placeholder="" style="width: 160px;" />
				</el-form-item>
                <el-form-item label="尺码">
					<el-input v-model="searchDate.size" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="结算状态">
					<el-select ref="state" v-model="searchDate.payed" placeholder="请选择" style="width: 160px;" @change="changeState">
						<el-option label="未结算" value="0">
						</el-option>
                        <el-option label="已结算" value="1">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item style="display: block;text-align: center;">
					<el-button @click="resetForm">重置</el-button>
					<el-button type="primary" @click="supersearch()">
						查询
					</el-button>
					<el-button @click="advancedDialog=false">
						取消
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
        <el-dialog title='字段选择' :visible.sync="printSetDialog" width="60%">
            <el-checkbox v-for="(column, index) in columns" :key="index" v-model="column.check" :label="column.label" @change="savePrintCols"/>
            <template #footer>
                <el-button type="primary" @click="printNow">打印</el-button>
                <el-button @click="printSetDialog = false">关闭</el-button>
            </template>
        </el-dialog>
        <ReportOrder ref="roder" :printCol="selectCols"></ReportOrder>
        <edit-share ref="share"></edit-share>
    </div>
</template>

<script>
import ReportOrder from '../../components/printshare/reportorder.vue';
import ColumnEdit from '@/components/table-column/Column.vue';
import Customer from '@/components/customer.vue';
import editShare from '../../components/printshare/edit_share';
export default {
    components: { ReportOrder,ColumnEdit,Customer,editShare },
    data() {
        return {
            loading:false,
            advancedDialog:false,
            printSetDialog:false,
            searchDate: {
                dateRan: "",
                number:"",
                cust:"",
                prod:"",
                notsend:"",
                remark:"",
                payed:"",
                state:"",
                color:"",
                szie:"",
                address:'',
            },
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            orderState:[
                {label:'全部',value:'-99'},
                {label:'已关闭',value:'-1'},
                {label:'待确认',value:'0'},
                {label:'已确认',value:'1'},
                {label:'部分开单',value:'3'},
                {label:'已开单',value:'4'},
                {label:'已锁定',value:'5'},
            ],
            currentPage: 1,
            cp_pagesize: 20,
            total: 100,
            tableData: [],
            searchType:1,
            multipleSelection:[],
            colsDialog:false,
            cols:[],
            searchObj:{},
            GLOBAL:this.$global,
            columns: [
                {
                    col: 'index',
                    label: '序号',
                    check: true
                },
                {
                    col: 'label',
                    label: '标签',
                    check: false
                },
                {
                    col: 'pnumber',
                    label: '货号',
                    check: true
                },
                {
                    col: 'code',
                    label: '条码',
                    check: false
                },
                {
                    col: 'prod',
                    label: '品名',
                    check: true
                },
                {
                    col: 'color',
                    label: '颜色',
                    check: false
                },
                {
                    col: 'size',
                    label: '尺码',
                    check: false
                },
                {
                    col: 'punit',
                    label: '单位',
                    check: true
                },
                {
                    col: 'amount',
                    label: '数量',
                    check: true
                },
                {
                    col: 'price',
                    label: '单价',
                    check: true
                },
                {
                    col: 'sendstate',
                    label: '已发',
                    check: false
                },
                {
                    col: 'unit',
                    label: '总数',
                    check: true
                },
                {
                    col: 'money',
                    label: '总金额',
                    check: true
                },
                {
                    col: 'remark',
                    label: '备注',
                    check: true
                },
                {
                    col: 'udate',
                    label: '修改日期',
                    check: false
                }
            ],
            selectCols:'',
        };
    },
    created() {
        let tt = this.$route.query.type;
        if(tt==0){
            this.searchType = 0;
        }
        this.searchObj = {
            page: this.currentPage,
            limit: this.cp_pagesize,
            type:this.searchType,
        };
        this.getOrderList();
        if(this.$global.userType==0){
            this.$api.getTableCols({tableName: 'ipad_orderList'}).then(res=>{
                if(res.data.code==1){
                    let obj = res.data.data;
                    if(obj.cols){
                        let arr = this.initCols();
                        obj.cols.forEach(e=>{
                            let prop = e.prop;
                            let show = e.show;
                            for(let i in arr){
                                if(arr[i].prop==prop){
                                    let target = arr.splice(i,1);
                                    target[0].show = show;
                                    this.cols.push(target[0]);
                                    break;
                                }
                            }
                        })
                        if(arr.length>0){
                            this.cols.push(...arr);
                        }
                    }else{
                        this.cols = this.initCols();
                    }
                }else{
                    this.cols = this.initCols();
                }
            })
        }else if(this.$global.userType==1){
            let temp = {
                share:0,
                key:'ipad_customer_orderList',
            }
            this.$api.getCustomerDataStorage(temp).then(res=>{
                if(res.data.code==1){
                    let obj = res.data.data.ipad_customer_orderList;
                    if(obj&&obj.length>0){
                        let arr = this.initCols();
                        obj.forEach(e=>{
                            let prop = e.prop;
                            let show = e.show;
                            for(let i in arr){
                                if(arr[i].prop==prop){
                                    let target = arr.splice(i,1);
                                    target[0].show = show;
                                    this.cols.push(target[0]);
                                    break;
                                }
                            }
                        })
                        if(arr.length>0){
                            this.cols.push(...arr);
                        }
                    }else{
                        this.cols = this.initCols();
                    }
                }else{
                    this.cols = this.initCols();
                }
            })
        }
        let temp = localStorage.getItem("orderCols");
        if(temp){
            let arr = JSON.parse(temp);
            if(arr&&arr.length>0){
                this.columns.forEach(e=>{
                    if(arr.indexOf(e.col)==-1){
                        e.check = false;
                    }else{
                        e.check = true;
                    }
                })
            }
        }
    },
    methods: {
        savePrintCols(){
            let arr = this.columns.filter(e=>e.check).map(e=>e.col);
            localStorage.setItem("orderCols",JSON.stringify(arr));
        },
        test(){
        },
        initCols(){
            let arr = [{
                prop: 'number',
                label: '订单编号',
                edit: '',
                type: 'linkType',
                width: 150,
                show: true,
                align:'left',
                column:'number',
            },{
                prop: 'customer',
                label: '客户',
                edit: '',
                type: '',
                width: 200,
                show: true,
                align:'left',
            },{
                prop: 'saler',
                label: '销售人员',
                edit: '',
                type: '',
                width: 100,
                show: true,
                align:'left',
            },{
                prop: 'date',
                label: '订货日期',
                edit: '',
                type: '',
                width: 160,
                show: true,
                align:'left',
                column:'date',
            },{
                prop: 'expect',
                label: '交货日期',
                edit: '',
                type: '',
                width: 160,
                show: true,
                align:'left',
            },{
                prop: 'totalUnit',
                label: '总数',
                edit: '',
                type: '',
                width: 150,
                show: true,
                align:'left',
            },{
                prop: 'paySum',
                label: '已支付(元)',
                edit: '',
                type: '',
                width: 150,
                show: true,
                align:'left',
            },{
                prop: 'sendstatus',
                label: '订单状态',
                edit: '',
                type: 'sendstatus',
                width: 100,
                show: true,
                align:'left',
            },{
                prop: 'payed',
                label: '结算状态',
                edit: '',
                type: '',
                width: 100,
                show: true,
                align:'left',   
            },{
                prop: 'remark',
                label: '备注',
                edit: '',
                type: '',
                width: 160,
                show: true,
                align:'left',
            },]
            if(this.$global.showProductPrice){
                arr.push({
                    prop: 'sum',
                    label: '总额(元)',
                    edit: '',
                    type: '',
                    width: 150,
                    show: true,
                    align:'left',
                });
                arr.push({
                    prop: 'paySum',
                    label: '还需支付(元)',
                    edit: '',
                    type: 'payType',
                    width: 150,
                    show: true,
                    align:'left',
                })
            }
            if(this.$global.useinstall==1){
                arr.push({
                    prop: 'insAdd',
                    label: '安装地址',
                    edit: '',
                    type: '',
                    width: 150,
                    show: true,
                })
            }
            return arr;
        },
        changeState(val){
            this.searchDate.payed = val;
            this.$refs.state.blur();
        },
        setState(val){
            let str = "设置";
            if(val==-2){
                str = "删除";
            }
            if(this.multipleSelection.length==0){
                this.$common.error('没有选择任何订单');
                return;
            }
            let arr = [];
            this.multipleSelection.forEach(e=>{
                arr.push(e.id);
            })
            let obj = {
                ids:arr.join(','),
                state:val,
            }
            this.$api.setOrderState(obj).then(res=>{
                if(res.data.code==1){
                    this.$notify({
                        title: str+"订单",
                        message: str+"成功",
                        type: "success",
                        duration: 1000,
                        onClose:()=>{
                            this.searchOrder();
                        }
                    });
                }else{
                    this.$common.error(res.data.msg);
                }
            })
        },
        resetForm(){
            this.searchDate.number="";
            this.searchDate.cust="";
            this.searchDate.prod="";
            this.searchDate.notsend="";
            this.searchDate.remark="";
            this.searchDate.payed="";
            this.searchDate.color="";
            this.searchDate.size="";
            this.searchDate.address="";
        },
        supersearch(){
            this.searchOrder();
            this.advancedDialog = false;
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.searchObj.column = this.searchDate.column;
                this.searchObj.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.searchObj.column;
                delete this.searchObj.order;
            }
            this.getOrderList();
        },
        searchOrder(){
            this.searchObj = {
                page: 1,
                limit: this.cp_pagesize,
                type:this.searchType,
            };
            this.currentPage = 1;
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.searchObj.datestart = this.searchDate.dateRan[0];
                this.searchObj.dateend = this.searchDate.dateRan[1];
            }
            if(this.searchDate.state>=-1){
                this.searchObj.state = this.searchDate.state;
            }
            if(this.searchDate.number){
                this.searchObj.number = this.searchDate.number;
            }
            if(this.searchDate.cust){
                this.searchObj.cust = this.searchDate.cust;
            }
            if(this.searchDate.prod){
                this.searchObj.prod = this.searchDate.prod;
            }
            if(this.searchDate.notsend){
                this.searchObj.notsend = this.searchDate.notsend;
            }
            if(this.searchDate.remark){
                this.searchObj.remark = this.searchDate.remark;
            }
            if(this.searchDate.payed){
                this.searchObj.payed = this.searchDate.payed;
            }
            if(this.searchDate.color){
                this.searchObj.color = this.searchDate.color;
            }
            if(this.searchDate.size){
                this.searchObj.size = this.searchDate.size;
            }
            if(this.searchDate.address){
                this.searchObj.address = this.searchDate.address;
            }
            this.sortTime();
        },
        viewOrder(val){
            this.searchType = val;
            this.currentPage = 1;
            this.searchObj = {
                page: this.currentPage,
                limit: this.cp_pagesize,
                type:this.searchType,
            };
            this.getOrderList();
        },
        seeOrderDetail(row){
            this.$router.push({
                    path: "/orderDetail",
                    query:{id:row.id,type:this.searchType},
                })
        },
        orderDetail(row) {
            if(this.$common.hasLimits("orderDetail")){
                this.$router.push({
                    path: "/editOrder",
                    query:{id:row.id,type:this.searchType},
                })
            }
        },
        handleSizeChange(val) {
            this.cp_pagesize = val;
            this.searchOrder();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchObj.page = val;
            this.getOrderList();
        },
        getOrderList() {
            this.loading = true;
            this.$api.getListOrder(this.searchObj).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = [];
                    this.total = res.data.count;
                    let dd = res.data.data.list;
                    dd.forEach((e) => {
                        let add = "";
                        e.contact.district.forEach((s) => {
                            add += s;
                        });
                        add += e.contact.address;
                        let orderinfo = {
                            id:e.id,
                            number: e.number,
                            date: e.date,
                            customer:e.customer.name,
                            saler: e.empName,
                            price: e.sum,
                            sendstatus: e.state,
                            remark: e.remark,
                            freeSum: e.freeSum,
                            paySum: e.paySum,
                            insAdd:e.address,
                            address: add,
                            name: e.contact.name,
                            phone: e.contact.phone,
                            expect:e.expect,
                            payed:e.payed==0?'未结算':'已结算',
                            totalUnit:this.$common.changeNumDesc(e,'totalAmount','totalParts','totalUnit'),
                            sum:e.sum,
                        };
                        this.tableData.push(orderinfo);
                    });
                    this.loading = false;
                }
            });
        },
        addOrder(){
            if(this.$common.checkLimits('addOrder')){
                this.$router.push('/addOrder')
            }
        },
        print(){
            if(this.multipleSelection.length>0){
                this.printSetDialog = true;
                
            }else{
                this.$common.error("没有选择订单");
            }
        },
        printNow(){
            this.selectCols = this.columns.filter(e=>e.check).map(e=>e.col).join(',');
            let array = [];
            this.multipleSelection.forEach(e=>{
                array.push(e.id);
            })
            this.$nextTick(()=>{
                this.$refs.roder.extraOpen(0,array);
            })
        },
        changePdf(){
            if(this.multipleSelection.length>0){
                let array = [];
                this.multipleSelection.forEach(e=>{
                    array.push(e.id);
                })
                this.$nextTick(()=>{
                    this.$refs.share.openList(array);
                })
            }else{
                this.$common.error("没有选择订单");
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        saveCols(){
            if(this.$global.userType==0){
                let obj = {
                    tableName:'ipad_orderList',
                    data:JSON.stringify(this.cols),
                }
                this.$api.setTableCols(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "列设置",
                            message: "修改成功",
                            type: "success",
                            duration: 2000,
                        });
                    }
                })
            }else if(this.$global.userType==1){
                let temp = {
                    ipad_customer_orderList:this.cols,
                }
                let obj = {
                    share:0,
                    data:JSON.stringify(temp),
                }
                this.$api.setCustomerDataStorage(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "列设置",
                            message: "修改成功",
                            type: "success",
                            duration: 2000,
                        });
                    }
                })
            }
            
            this.colsDialog = false;
        },
        orderDelete(row){
            let id = row.id;
            this.$confirm("警告", {
                title: "警告",
                message: '确定删除订单',
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(
                ()=>{
                    let obj = {
                        ids:id,
                        state:-2,
                    }
                    this.$api.setOrderState(obj).then(res=>{
                        if(res.data.code==1){
                            this.$notify({
                                title: "订单删除",
                                message: "删除成功",
                                type: "success",
                                duration: 2000,
                            });
                            this.getOrderList();
                        }else{
                            this.$common.error(res.data.msg);
                        }
                    })
                }
            )
        }
    },
};
</script>